import moment from "moment-jalaali";

export const TimePeriodSelector = (time) => {
  let date;
  switch (time) {
    case "yesterday":
      date = moment().add(1, "days");
      break;
    case "today":
      date = moment();
      break;
    case "month":
      date = moment().add(1, "months");
      break;
    case "tom":
      date = moment().add(1, "days");
      break;
    case "week":
      date = moment().add(1, "weeks");
      break;
    default:
      return false;
  }
  return {
    FromDate: moment().format("jYYYY/jM/jD"),
    ToDate: date.format("jYYYY/jM/jD"),
  };
};
